import React, { useEffect, useRef } from 'react';
import { Route } from 'react-router-dom';
import { isManagerAuthenticated } from '../credentials/authManager';

export default function PrivateManagerRoute({ component: Component, ...rest }) {
    const { handleShowInfo, handleScrollAtivated, ...routeProps } = rest;
    const hasInitialized = useRef(false);

    useEffect(() => {
        // Executa apenas uma vez, independente das dependências
        if (!hasInitialized.current) {
            if (handleShowInfo) {
                handleShowInfo(true);
            }
            if (handleScrollAtivated) {
                handleScrollAtivated();
            }
            hasInitialized.current = true;
        }
    });

    return (
        <Route 
            {...routeProps} 
            render={props => {
                if (isManagerAuthenticated()) {
                    return (
                        <Component 
                            {...props}
                            {...rest}
                        />
                    );
                } else {
                    // Redireciona para login ou exibe mensagem de não autorizado
                    return (
                        <div style={{ 
                            marginTop: '75px', 
                            textAlign: 'center',
                            padding: '20px',
                            color: '#d32f2f'
                        }}>
                            <h1>Acesso não autorizado!</h1>
                            <p>Você não tem permissão para acessar esta página como gestor.</p>
                            <p>Por favor, faça login com uma conta de gestor válida.</p>
                        </div>
                    );
                }
            }}
        />
    );
}